// https://dev.to/elsyng/react-modal-dialog-using-html-dialog-element-5afk

import { useEffect, useRef } from "react"
import styles from "./HTMLDialogModal.module.scss"
import { IconButton } from "@mui/material"
import { Close } from "../../svgs/Close"
import classNames from "classnames"

type HTMLDialogModalProps = {
    isOpened: boolean
    onProceed: () => void
    onClose: () => void
    children: React.ReactNode
  innerModalCSS?
  outerModalCSS?
}
const HTMLEmptyModal = ({
    isOpened,
    onProceed,
    onClose,
    children,
  innerModalCSS,
  outerModalCSS
}: HTMLDialogModalProps) => {
    const ref = useRef<HTMLDialogElement>(null)

    useEffect(() => {
        console.log(ref.current)
        if (isOpened) {
            if (!ref.current.open) {
                ref.current?.showModal()
                document.body.classList.add("modal-open") // prevent bg scroll
            }
        } else {
            ref.current?.close()
            document.body.classList.remove("modal-open")
        }
    }, [isOpened])

    const proceedAndClose = () => {
        onProceed()
        onClose()
    }

    const preventAutoClose = (e: React.MouseEvent) => e.stopPropagation()

    return (<dialog
                    className={classNames(styles.htmlDialog, outerModalCSS)}
                    ref={ref}
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onCancel={(e) => {
                        e.stopPropagation()
                        onClose()
                    }}
                    onKeyDown={(event) => {
                        if (event.key == "Escape") {
                            event.stopPropagation()
                            onClose()
                        }
                    }}
                    onClick={(e) => {
                        e.stopPropagation()
                        onClose()
                    }}
            >
                    <IconButton
                            className={styles.close}
                            onClick={(e) => {
                                e.stopPropagation()
                                onClose()
                            }}
                    >
                        <Close type={"outlined"} fill={"#41919E"} />
                    </IconButton>
                <div
                        // style={{  overflow: "auto" }}
                        className={innerModalCSS}
                        onClick={preventAutoClose}
                >
                    {children}
                </div>
            </dialog>)
}

export default HTMLEmptyModal